import { render, staticRenderFns } from "./SuggestedEnhancementMobile.vue?vue&type=template&id=4348ffd0&scoped=true&"
import script from "./SuggestedEnhancementMobile.vue?vue&type=script&lang=js&"
export * from "./SuggestedEnhancementMobile.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedEnhancementMobile.vue?vue&type=style&index=0&id=4348ffd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4348ffd0",
  null
  
)

export default component.exports